<template>
  <DxPopup
    :visible="popupConfig.isPopupShow"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="false"
    :show-close-button="false"
    :show-title="true"
    :width="'600px'"
    :height="'auto'"
    title="Lock Accounting Periods"
    :wrapper-attr="{
      class: 'css-v2 gc-popup gc-popup-lock-accounting-period',
    }"
    ref="gc-popup"
  >
    <DxToolbarItem
      widget="dxButton"
      location="after"
      toolbar="top"
      :options="{
        text: '',
        icon: 'close',
        stylingMode: 'text',
        type: 'default',
        onClick: onPopupHide,
      }"
    />

    <div class="css-v2 gc-popup-form">
      <dx-data-grid
        :data-source="periods"
        :show-borders="true"
        :row-alternation-enabled="true"
        :column-auto-width="true"
        :width="'100%'"
        ref="lockPeriodGrid"
        :columns="getColumns"
        :pager="{ visible: false }"
        :paging="{ enabled: false }"
        :column-chooser="{ enabled: false }"
        :search-panel="{ visible: false }"
      >
        <template #lockButtonTemplate="{ data }">
          <dx-button
            width="100%"
            styling-mode="outlined"
            @click="onLockClick(data)"
          >
            <span class="lock-btn-content">
              <i class="dx-icon dx-icon-lock"></i>
              <span>Lock</span>
            </span>
          </dx-button>
        </template>
      </dx-data-grid>
    </div>
  </DxPopup>
</template>

<script>
import { AccountingPeriodService } from "../../_services/api/settings/accounting/accounting-period.service";

export default {
  props: {
    popupConfig: {
      type: Object,
      default: () => ({ isPopupShow: false }),
    },
    onHide: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      periods: [],
    };
  },
  computed: {
    getColumns() {
      return [
        {
          dataField: "Module",
          caption: "Module",
        },
        {
          dataField: "Code",
          caption: "ID",
        },
        {
          dataField: "CanedarMonth",
          caption: "Calendar Month",
        },
        {
          dataField: "FiscalYear",
          caption: "Fiscal Year",
          alignment: "left",
        },
        {
          caption: "",
          dataField: "",
          cellTemplate: "lockButtonTemplate",
          width: 110,
          fixed: true,
          fixedPosition: "right",
          allowSorting: false,
        },
      ];
    },
  },
  async mounted() {
    await this.loadPeriods();
  },
  methods: {
    getGridInstance() {
      if (this.$refs.lockPeriodGrid && this.$refs.lockPeriodGrid.instance) {
        return this.$refs.lockPeriodGrid.instance;
      }
      return null;
    },

    beginLoading() {
      var grid = this.getGridInstance();
      if (grid) grid.beginCustomLoading("");
    },

    endLoading() {
      var grid = this.getGridInstance();
      if (grid) grid.endCustomLoading();
    },

    async loadPeriods() {
      this.beginLoading();
      try {
        const response = await AccountingPeriodService.getCurrentActivePeriods();
        if (response && response.data && response.data.value) {
          this.periods = response.data.value;
        }
      } catch (error) {
        this.$store.dispatch("ui/setServerError", { error });
      } finally {
        this.endLoading();
      }
    },

    async onLockClick(cellData) {
      const row = cellData.data;
      const moduleMessages = {
        AP: `Do you wish to Lock the current Accounts Payable period?`,
        AR: `Do you wish to close the current Accounts Receivable period?`,
        GL: `Do you wish to Lock the current General Ledger period?`,
        STK: `Do you wish to Lock the current Inventory period?`,
      };
      const confirmMessage = moduleMessages[row.TYPE];
      const confirmed = await this.$confirm(confirmMessage, "Lock Period");

      if (!confirmed) return;

      this.beginLoading();
      try {
        const response = await AccountingPeriodService.endOfPeriod(row.TYPE);
        await this.loadPeriods();
        const message = response && response.data && response.data.Message
          ? response.data.Message
          : `${row.Module} period has been locked successfully.`;
        this.$alert(message, "Information");
      } catch (error) {
        this.$store.dispatch("ui/setServerError", { error });
        this.endLoading();
      }
    },

    onPopupHide() {
      this.onHide();
    },
  },
};
</script>

<style lang="scss">
.gc-popup-lock-accounting-period {
  .gc-popup-form {
    padding: 16px;
  }

  .lock-btn-content {
    display: inline-flex;
    align-items: center;
    gap: 4px;

    .dx-icon-lock {
      font-size: 14px;
    }
  }
}
</style>
